import { AxiosError } from 'axios';
import { useState } from 'react';
import useHttps from './useHttps';
import {
  HttpConfig,
  SuccessHttpResponse,
  ErrorHttpResponse,
} from '../models/https';
import toast from 'react-hot-toast';

const useSetApplicationStatus = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const setApplicationStatus = (appId: string, payload: { status: string }) => {
    const config: HttpConfig = {
      url: `jobs-service/applications/${appId}/status`,
      method: 'patch', // or 'patch' if your API uses that
      data: payload,
    };

    return request(
      config,
      ({ data, message }: SuccessHttpResponse<any>) => {
        toast.success(message);
      },
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
          err?.response?.data?.message ?? 'Failed to update application status'
        );
        console.error(err);
      }
    );
  };

  return { setApplicationStatus, loading };
};

export default useSetApplicationStatus;
